document.addEventListener('DOMContentLoaded', () => {
  const formatPrice = (cents) => new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'EUR'
  }).format(cents / 100);

  /* Accordeon FAQ — meme comportement que product.js, qui n est pas charge
     sur ce gabarit. Une seule reponse ouverte a la fois. */
  document.querySelectorAll('[data-accordion] .faq-item').forEach((item) => {
    const question = item.querySelector('.faq-question');
    if (!question) return;

    question.addEventListener('click', () => {
      const container = item.closest('[data-accordion]');
      const wasOpen = item.classList.contains('active');
      container.querySelectorAll('.faq-item.active').forEach((open) => open.classList.remove('active'));
      if (!wasOpen) item.classList.add('active');
    });
  });

  /* Ajout au panier : le formulaire natif de Shopify poste sur /cart/add et
     EMMENE la cliente sur la page panier. Tout le reste du site ouvre le
     tiroir (cart.js). On intercepte donc l envoi et on delegue a KaelaCart,
     qui ajoute la variante choisie puis ouvre le tiroir. Si cart.js n est pas
     charge, on laisse partir l envoi natif : mieux vaut la page panier que
     rien du tout. */
  document.querySelectorAll('.device-main form[action*="/cart/add"]').forEach((form) => {
    form.addEventListener('submit', (event) => {
      if (!window.KaelaCart || typeof window.KaelaCart.addVariant !== 'function') return;
      const idField = form.querySelector('[name="id"]');
      const variantId = parseInt(idField && idField.value, 10);
      if (!variantId) return;
      event.preventDefault();
      const qtyField = form.querySelector('[name="quantity"]');
      window.KaelaCart.addVariant(variantId, parseInt(qtyField && qtyField.value, 10) || 1);
    });
  });

  document.querySelectorAll('.device-main').forEach((section) => {
    const gallery = section.querySelector('[data-device-gallery]');

    if (gallery) {
      const viewport = gallery.querySelector('[data-device-gallery-viewport]');
      const slides = Array.from(gallery.querySelectorAll('[data-device-slide]'));
      const thumbs = Array.from(gallery.querySelectorAll('[data-device-thumb]'));
      const prev = gallery.querySelector('[data-device-gallery-prev]');
      const next = gallery.querySelector('[data-device-gallery-next]');
      let current = 0;
      let touchStartX = null;

      const showSlide = (index) => {
        current = (index + slides.length) % slides.length;
        slides.forEach((slide, slideIndex) => {
          const isActive = slideIndex === current;
          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        });
        thumbs.forEach((thumb, thumbIndex) => {
          const isActive = thumbIndex === current;
          thumb.classList.toggle('is-active', isActive);
          thumb.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
      };

      thumbs.forEach((thumb, index) => {
        thumb.addEventListener('click', () => showSlide(index));
      });

      if (prev) prev.addEventListener('click', () => showSlide(current - 1));
      if (next) next.addEventListener('click', () => showSlide(current + 1));

      if (viewport) {
        viewport.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') showSlide(current - 1);
          if (event.key === 'ArrowRight') showSlide(current + 1);
        });
        viewport.addEventListener('touchstart', (event) => {
          touchStartX = event.touches[0].clientX;
        }, { passive: true });
        viewport.addEventListener('touchend', (event) => {
          if (touchStartX === null) return;
          const distance = event.changedTouches[0].clientX - touchStartX;
          if (Math.abs(distance) > 40) showSlide(distance < 0 ? current + 1 : current - 1);
          touchStartX = null;
        }, { passive: true });
      }

      showSlide(0);
    }

    const purchase = section.querySelector('[data-device-purchase]');
    const quantityInput = purchase && purchase.querySelector('[data-device-quantity]');
    const minus = purchase && purchase.querySelector('[data-device-quantity-minus]');
    const plus = purchase && purchase.querySelector('[data-device-quantity-plus]');
    const subtotal = purchase && purchase.querySelector('[data-device-subtotal]');
    const mobileQuantity = section.querySelector('[data-device-mobile-quantity]');
    let unitPrice = purchase ? parseInt(purchase.dataset.unitPrice, 10) || 0 : 0;

    const syncQuantity = (requestedValue) => {
      if (!quantityInput) return;
      const minimum = parseInt(quantityInput.min, 10) || 1;
      const maximum = parseInt(quantityInput.max, 10) || 99;
      const quantity = Math.min(maximum, Math.max(minimum, parseInt(requestedValue, 10) || minimum));
      quantityInput.value = quantity;
      if (mobileQuantity) mobileQuantity.value = quantity;
      if (subtotal) subtotal.textContent = formatPrice(unitPrice * quantity);
      if (minus) minus.disabled = quantity <= minimum;
      if (plus) plus.disabled = quantity >= maximum;
    };

    if (minus) minus.addEventListener('click', () => syncQuantity(Number(quantityInput.value) - 1));
    if (plus) plus.addEventListener('click', () => syncQuantity(Number(quantityInput.value) + 1));
    if (quantityInput) quantityInput.addEventListener('change', () => syncQuantity(quantityInput.value));
    syncQuantity(quantityInput ? quantityInput.value : 1);

    /* Nuancier : la case choisie porte le nom affiche a cote de « Coloris »
       et alimente la propriete de ligne, sinon le choix serait purement
       decoratif et n arriverait jamais dans la commande. */
    const shadeGroup = section.querySelector('[data-device-shades]');
    const variantSelect = section.querySelector('[data-device-variant-select]');

    if (shadeGroup) {
      const shades = Array.from(shadeGroup.querySelectorAll('[data-device-shade]'));
      const shadeName = shadeGroup.querySelector('[data-device-shade-name]');
      const shadeInput = shadeGroup.querySelector('[data-device-shade-input]');

      shades.forEach((shade) => {
        shade.addEventListener('click', () => {
          if (shade.disabled) return;
          shades.forEach((other) => {
            const isSelected = other === shade;
            other.classList.toggle('is-selected', isSelected);
            other.setAttribute('aria-checked', isSelected ? 'true' : 'false');
          });
          const name = shade.dataset.shadeName || '';
          if (shadeName) shadeName.textContent = name;
          if (shadeInput) shadeInput.value = name;
          if (variantSelect && shade.dataset.variantId) {
            variantSelect.value = shade.dataset.variantId;
            variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      });
    }

    const mobileVariant = section.querySelector('.device-mobile-atc input[name="id"]');
    const desktopPrice = section.querySelector('[data-device-price]');
    const desktopCompare = section.querySelector('[data-device-compare]');
    const mobilePrice = section.querySelector('[data-device-mobile-price]');
    const stockMessage = section.querySelector('[data-device-stock]');
    const availabilityMessage = section.querySelector('[data-device-availability]');
    const reassurance = section.querySelector('[data-device-reassurance]');
    const desktopAtc = purchase && purchase.querySelector('.device-atc');
    const mobileAtc = section.querySelector('.device-mobile-atc button[type="submit"]');

    if (variantSelect) {
      variantSelect.addEventListener('change', () => {
        const option = variantSelect.selectedOptions[0];
        if (!option) return;

        if (mobileVariant) mobileVariant.value = option.value;
        if (desktopPrice && option.dataset.price) desktopPrice.textContent = option.dataset.price;
        if (mobilePrice && option.dataset.price) mobilePrice.textContent = option.dataset.price;
        if (desktopCompare) {
          desktopCompare.textContent = option.dataset.compare || '';
          desktopCompare.hidden = !option.dataset.compare;
        }
        const available = option.dataset.available === 'true';
        const inventory = Math.max(0, parseInt(option.dataset.inventory, 10) || 0);

        if (stockMessage) {
          stockMessage.textContent = available
            ? (inventory > 0 && inventory <= 5 ? `Plus que ${inventory} en stock` : 'En stock')
            : 'Épuisé';
        }
        /* Coloris epuise : on echange le bandeau de reassurance contre le
           message, au lieu d ecrire un texte de stock par-dessus. */
        if (reassurance) reassurance.hidden = !available;
        if (availabilityMessage) {
          availabilityMessage.hidden = available;
          availabilityMessage.textContent = available ? '' : 'Ce coloris est actuellement indisponible.';
        }
        [desktopAtc, mobileAtc].forEach((button) => {
          if (!button) return;
          button.disabled = !available;
          button.textContent = available ? 'Ajouter au panier' : 'Épuisé';
        });
        if (quantityInput && inventory > 0) quantityInput.max = Math.min(5, inventory);
        unitPrice = parseInt(option.dataset.priceCents, 10) || unitPrice;
        if (purchase) purchase.dataset.unitPrice = unitPrice;
        syncQuantity(quantityInput ? quantityInput.value : 1);
      });

      variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });
});
